import React, { useContext } from "react";
import { AppContext } from "../context/app.context";

/**
 * Jev window (2026-10-07) — header circle button that opens the live Jev
 * shadow-mode viewer. Shown only when canAccessJev passes (the "jev" token in
 * tsUserDocument.screenAccessList); available on every screen, like Compass.
 * Same circular outline style as the 🧭 Compass and 📊 Dashboard buttons.
 */
const JevButton = () => {
  const { setOpenJevModal } = useContext(AppContext);
  return (
    <button
      onClick={() => setOpenJevModal({ show: true })}
      type="button"
      title="Jev"
      aria-label="Open Jev"
      className="w-7 h-7 ml-4 rounded-full border-2 border-skin-link text-skin-link font-bold leading-none flex items-center justify-center hover:opacity-75"
    >
      <span aria-hidden="true">{"\u{1F9E0}"}</span>
    </button>
  );
};

export default JevButton;
